import { lazyComponent } from '@unisporkal/react-lazy-component';
import { configureSearchStore, configureErrorPageStore } from 'app/store';
import Search from 'app/root-components/search/shared/Search';
import withProviders from '../Providers';

export const components = {
  istock: {
    Search: {
      Component: Search,
      configureStore: configureSearchStore,
    },
    FourTen: {
      Component: lazyComponent(() =>
        import('app/root-components/search/istock/FourTen')
      ),
      configureStore: configureErrorPageStore,
    },
    FourOhFour: {
      Component: lazyComponent(() =>
        import('app/root-components/search/istock/FourOhFour')
      ),
      configureStore: configureErrorPageStore,
    },
  },
  getty: {
    Search: {
      Component: Search,
      configureStore: configureSearchStore,
    },
    EditorialLanding: {
      Component: lazyComponent(() =>
        import('app/root-components/search/getty/EditorialLanding')
      ),
      configureStore: configureSearchStore,
    },
    FourTen: {
      Component: lazyComponent(() =>
        import('app/root-components/search/getty/FourTen')
      ),
      configureStore: configureErrorPageStore,
    },
    FourOhFour: {
      Component: lazyComponent(() =>
        import('app/root-components/search/getty/FourOhFour')
      ),
      configureStore: configureErrorPageStore,
    },
  },
};

function siteComponent(site, componentName) {
  let component = null;
  const forSite = components[site];
  if (forSite) {
    component = forSite[componentName];
  }
  if (!component) {
    throw new Error(`No component mapped for ${site}:${componentName}`);
  }
  const { Component, configureStore } = component;

  return {
    Component: withProviders(Component),
    configureStore,
  };
}

export default siteComponent;
